import React from 'react';
import SwitchField from 'components/Fields/ReduxForm/SwitchField';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import styles from './DescriptiveSwithField.css';

class DescriptiveSwitchField extends React.Component {
  render() {
    return (
      <div
        className={`${styles['form-group']} row ${this.props.wrapperClassName}`}
      >
        <div className="col-lg-9 col-md-9 col-sm-6">
          <div className={styles.label}>{this.props.label}</div>
          <div className={styles.sublabel}>{this.props.sublabel}</div>
          <div className={styles['additional-text']}>
            {this.props.additionalText}
          </div>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-6">
          <div className={styles['field-right']}>
            <Field
              component={SwitchField}
              name={this.props.name}
              type="checkbox"
              disabled={this.props.disabled}
              disabledTooltipText={this.props.disabledTooltipText}
            />
          </div>
        </div>
      </div>
    );
  }
}

DescriptiveSwitchField.propTypes = {
  label: PropTypes.string,
  sublabel: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  disabledTooltipText: PropTypes.string,
  wrapperClassName: PropTypes.string,
  // we using value from redux form so no props of value here
};

DescriptiveSwitchField.defaultprops = {
  disabled: false,
  disabledTooltipText: 'This field is disabled',
  wrapperClassName: '',
};

export default DescriptiveSwitchField;
